<template>
  <div>
    <b-row>
      <b-col cols="6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i>
            Change Password
          </div>
          <div class="card-body">
            <b-form @submit="onSubmit">
              <b-form-group id="input-group-1" label="Current Password:" label-for="input-1" class="required">
                <b-form-input
                  id="input-1"
                  v-model="form.currentPassword"
                  type="password"
                  :class="{ 'is-invalid': $v.form.currentPassword.$error }"
                  @blur="$v.form.currentPassword.$touch()"
                  placeholder="Enter current Password"
                ></b-form-input>
                <b-form-invalid-feedback>Current password is required</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group id="input-group-2" label="New Password:" label-for="input-2" class="required">
                <b-form-input
                  id="input-2"
                  v-model="form.newPassword"
                  type="password"
                  :class="{ 'is-invalid': $v.form.newPassword.$error }"
                  @blur="$v.form.newPassword.$touch()"
                  placeholder="Enter new Password"
                ></b-form-input>
                <b-form-invalid-feedback>New password is required</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group id="input-group-3" label="Confirm Password:" label-for="input-2" class="required">
                <b-form-input
                  id="input-3"
                  v-model="form.confirmPassword"
                  type="password"
                  :class="{ 'is-invalid': $v.form.confirmPassword.$error }"
                  @blur="$v.form.confirmPassword.$touch()"
                  placeholder="Enter confirm Password"
                ></b-form-input>
                <b-form-invalid-feedback>Confirm password must be same as new password</b-form-invalid-feedback>
              </b-form-group>
              <b-button type="submit" variant="primary" :disabled="isSaving" class="mt-1">
                <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Submit</b-button>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { userService } from '@/pages/Users/serviceLogin';
import { required, sameAs } from 'vuelidate/lib/validators';
export default {
  metaInfo: () => ({
    title: 'Change Password',
  }),
  data() {
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      isSaving: false,
    };
  },
  validations: {
    form: {
      currentPassword: { required, },
      newPassword: { required },
      confirmPassword: { required, sameAsPassword: sameAs('newPassword') },
    },
  },
  computed: {
    ...mapState('account', ['user']),
  },
  methods: {
    onSubmit: function(evt) {
      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      let id = this.user.id;
      if (id === undefined) {
        let user = JSON.parse(localStorage.getItem('user'));
        id = user.id;
      }
      try {
        this.isSaving = true;
        userService
          .changePassword(
            id,
            this.form.currentPassword,
            this.form.newPassword,
            this.form.confirmPassword
          )
          .then((result) => {
            if (result) {
              this.$snotify.success('Password updated successfully', 'Password');
            } else {
              this.$snotify.warning('Wrong password or mismatch', 'Password');
            }
            this.form.currentPassword = '';
            this.form.newPassword = '';
            this.form.confirmPassword = '';
            this.$v.$reset();
            this.isSaving = false;
          });
      }catch (e) {
        this.isSaving = false;
      }
    },
  },
};
</script>

